import { Link } from "react-router-dom";
import { Sun } from "lucide-react";

/**
 * Footer landing (S7-5, GAP-3).
 *
 * Contenu minimal :
 * - Logo + libellé SunMatch + mention bêta.
 * - Lien `Politique de confidentialité` (obligation RGPD art. 13).
 * - Copyright + année courante.
 *
 * On dérive l'année du `Date` côté rendu pour rester correct au passage
 * de minuit le 1er janvier sans rebuild.
 */
export function LandingFooter(): JSX.Element {
  const year = new Date().getFullYear();
  return (
    <footer
      aria-label="Pied de page"
      className="border-t border-slate-200 bg-slate-50 py-8"
    >
      <div className="mx-auto flex max-w-6xl flex-col items-center justify-between gap-4 px-4 sm:flex-row">
        <div className="flex items-center gap-2 text-sm text-slate-700">
          <Sun className="h-4 w-4 text-amber-500" aria-hidden />
          <span className="font-medium text-slate-900">SunMatch</span>
          <span className="rounded-full bg-amber-100 px-2 py-0.5 text-xs font-medium text-amber-900">
            bêta
          </span>
        </div>
        <nav aria-label="Liens légaux" className="flex items-center gap-6">
          <Link
            to="/politique-confidentialite"
            className="text-sm text-slate-700 underline-offset-4 hover:underline focus-visible:underline"
          >
            Politique de confidentialité
          </Link>
        </nav>
        <p className="text-xs text-slate-600">
          © {year} SunMatch — Tous droits réservés.
        </p>
      </div>
    </footer>
  );
}
